import Box from "@mui/material/Box";
import styled from "@mui/material/styles/styled";
import { signInWith } from "../api/account";
import { useNotificationContext } from "../providers/NotificationProvider";

type Props = {
  type?: "login" | "signup";
};

const GoogleSignUp = ({ type }: Props) => {
  const { showNotification } = useNotificationContext();

  return (
    <StyledContainer
      onClick={async () => {
        const result = await signInWith("google");
        if (result?.isNewUser) {
          showNotification("アカウントを作成しました");
        } else {
          showNotification("ログインしました");
        };
      }}
    >
      <Box>Googleで{type === "login" ? "ログイン" : "登録"}</Box>
    </StyledContainer>
  )
};

const StyledContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  borderRadius: 4,
  gap: theme.spacing(1.5),
  padding: theme.spacing(2),
  backgroundColor: "#fff",
  fontWeight: 700,
  cursor: "pointer",
  border: "1px solid #f0f0f0",
}));

export default GoogleSignUp;
